// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__2UpTb","actionColumn":"ReferralSources_actionColumn__13DT2","textButton":"ReferralSources_textButton__3HkCG"};